import React from "react";
import OrangeOverLay from "../../../assets/htbd-images/OrangeOverLay.png";
import BlueOverLay from "../../../assets/htbd-images/BlueOverLay.png";

export default function BackroundGradient() {
  return (
    <>
      <span
        className="position-absolute start-0 translate-middle-x"
        style={{ zIndex: -1, top: "-200%" }}
      >
        <img src={OrangeOverLay} alt="zikzak" />
      </span>
      <span
        className="position-absolute end-0"
        style={{ zIndex: -1, top: -50 }}
      >
        <img src={BlueOverLay} alt="Group" />
      </span>
    </>
  );
}
